<div class="row">
	<div class="col-md-3">
		<img [src]="event.postcard" class="img-responsive" alt="" />
	</div>
	<div class="col-md-9">
		<h2 class="margin-top-0">{{ event.name }}</h2>

		<div style="margin-bottom: 15px">
			<a
				*ngIf="showDashboardLink"
				[routerLink]="['/ez', 'events', event.code]"
				class="btn btn-primary"
			>
				See Event Dashboard
			</a>

			<a
				*ngIf="showDayOfLink"
				[routerLink]="['/ez2', 'events', event.code]"
				class="btn btn-primary"
				style="margin-left: 15px"
			>
				See Day of Tools
			</a>
		</div>

		<ul>
			<li><strong>Date:</strong> {{ event.date | ezMomentDate }}</li>
			<li>
				<strong>Website:</strong>
				<a [href]="event.url" target="_blank">{{ event.url }}</a>
			</li>
			<li><strong>Email:</strong> {{ event.email }}</li>
		</ul>

		<br />

		<h3>Registration Links</h3>

		<table class="table">
			<thead>
				<th>Registration</th>
				<th>Deadline</th>
				<th>Link</th>
			</thead>
			<tbody>
				<tr *ngFor="let deadline of event.deadlinesArr">
					<th>
						{{ capFirst(deadline.registrationType) }}
					</th>
					<td>
						<span
							*ngIf="
								deadline.deadline === 'closed';
								else deadlineDate
							"
						>
							Closed
						</span>
						<ng-template #deadlineDate>
							{{ deadline.deadline | ezMomentDate }}
						</ng-template>
					</td>
					<td>
						<div class="input-group">
							<input
								type="text"
								class="form-control"
								style="width: 100%"
								readonly="true"
								[value]="getRegistrationLink(deadline)"
								onclick="this.select()"
								#link
							/>
							<span class="input-group-btn">
								<button
									class="btn btn-default"
									type="button"
									(click)="copyInputMessage(link)"
								>
									<i class="fa fa-clipboard"></i>
								</button>
							</span>
							<span class="input-group-btn">
								<a
									class="btn btn-default"
									target="_blank"
									[href]="getRegistrationLink(deadline)"
								>
									<i class="fa fa-external-link"></i>
								</a>
							</span>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<ng-container *ngIf="documents.length > 0">
	<h3>Documents</h3>

	<div class="row">
		<div class="col-xs-6 col-md-3" *ngFor="let document of documents">
			<a [href]="document.url" target="_blank" class="document-card">
				<div style="margin-bottom: 15px; font-weight: bold">
					Document:
				</div>
				<div style="font-size: 1.5em">
					{{ document.name }}
				</div>
			</a>
		</div>
	</div>
</ng-container>
